import { ITabletData } from "api/types";
import { ILoggedCustomer } from "api/types";
import TabletInfoAnnotation from "components/common/TabletInfoAnnotation/TabletInfoAnnotation";
import {
  ConfigurationLoaderContext,
  IConfiguration
} from "components/Gates/ConfigurationLoaderGate";
import { LockGateContext } from "components/Gates/LockGate";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import Splash from "components/Splash/KiosModeSplashScreen";
import { History } from "history";
import * as React from "react";
import { Routes } from "router";
import WelcomeBoard from "screens/Onboarding/WelcomeBoard/WelcomeBoard";
import version from "version";

interface IProps {
  tabletConfig: IConfiguration;
  tabletData: ITabletData;
  history: History;
  isAppIdle?: boolean;
}

interface IState {
  waiting: boolean;
}

class Kiosk extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {
      waiting: true
    };
  }

  public componentDidMount() {
    this.setState({
      waiting: true
    });
  }

  public render() {
    const { tabletData, tabletConfig, history } = this.props;
    const { waiting } = this.state;

    return (
      <>
        {!waiting && (
          <>
            <WelcomeBoard
              history={history}
              onSignUp={this.onSignUp}
              canSignIn={false}
              tabletData={tabletData}
              handleCustomerSession={this.handleCustomerSession}
            />
            <TabletInfoAnnotation version={version} tabletData={tabletData} />
          </>
        )}
        {waiting && (
          <Splash
            onClick={this.stopWaiting}
            splashScreenUrl={this.getSplashScreen()}
          />
        )}
      </>
    );
  }

  public componentDidUpdate(prevProps: IProps) {
    if (this.props.isAppIdle && !prevProps.isAppIdle && !this.state.waiting) {
      this.setState({ waiting: true });
    }
  }

  private getSplashScreen = () => {
    const { tabletConfig, tabletData } = this.props;
    const rewardsFlowIsEnabed =
      tabletData.locationSettings.showTabletRewardsFlow;
    if (rewardsFlowIsEnabed) {
      return tabletConfig.rewards_flow_enabled_kiosk_splash_image_url;
    } else {
      return tabletConfig.kiosk_splash_image_url;
    }
  };

  private stopWaiting = () =>
    this.setState({
      waiting: false
    });

  private handleCustomerSession = (loggedCustomer: ILoggedCustomer) => {
    console.log("handle Customer Session", loggedCustomer);
    if (loggedCustomer.newCustomer) {
      this.props.history.push(Routes.KioskWelcome);
    } else {
      this.props.history.push(Routes.KioskWelcomeToLocation);
    }
  };

  private onSignUp = () => this.props.history.push(Routes.KioskWelcome);
}

export default (props: IProps) => (
  <TabletDataContext.Consumer>
    {tabletData =>
      tabletData && (
        <LockGateContext.Consumer>
          {LockGateState => (
            <ConfigurationLoaderContext.Consumer>
              {config =>
                config && (
                  <Kiosk
                    isAppIdle={LockGateState.idle}
                    tabletData={tabletData}
                    tabletConfig={config}
                    {...props}
                  />
                )
              }
            </ConfigurationLoaderContext.Consumer>
          )}
        </LockGateContext.Consumer>
      )
    }
  </TabletDataContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/screens/Kiosk/index.tsx